import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { Input } from "./input";

export const PasswordInput = ({ className = "", ...props }) => {
  const [show, setShow] = useState(false);
  const { id, "data-testid": testid } = props;
  return (
    <div className="relative">
      <Input type={show ? "text" : "password"} autoComplete="off" className={`pr-10 ${className}`} {...props} />
      <button
        type="button"
        onClick={() => setShow((s) => !s)}
        aria-label={show ? "Sembunyikan password" : "Tampilkan password"}
        aria-pressed={show}
        data-testid={testid ? `${testid}-toggle` : undefined}
        className="absolute right-1 top-1/2 -translate-y-1/2 h-8 w-8 grid place-items-center rounded-md text-muted-foreground hover:text-foreground hover:bg-muted/70 transition-colors"
      >
        {show ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
      </button>
    </div>
  );
};
